<tokens-browser-verify-pincode [pincode]="getPincode()" (verifyPincode)="onVerifyPincode()" (back)="onBack()"
    >>
</tokens-browser-verify-pincode>
